import ViewMask from './view-mask.vue'

export default ViewMask



// WEBPACK FOOTER //
// ./src/views/my-components/view-mask/index.js